import React from 'react';
import { motion } from 'framer-motion';
import { ScrollReveal } from './ScrollReveal';
export const IntroText = () => {
  return <section className="bg-brand-darker py-20 md:py-28 lg:py-40" data-id="element-114">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12" data-id="element-115">
        <div className="max-w-3xl" data-id="element-116">
          <ScrollReveal data-id="element-117">
            <motion.div initial={{
            scaleX: 0
          }} whileInView={{
            scaleX: 1
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 1,
            ease: [0.16, 1, 0.3, 1]
          }} className="h-[1px] w-16 md:w-24 bg-brand-border mb-8 md:mb-12 origin-left" data-id="element-118" />
          </ScrollReveal>

          <ScrollReveal delay={0.2} blur="8px" distance={40} data-id="element-119">
            <div className="max-w-prose space-y-6 text-lg md:text-2xl lg:text-3xl text-brand-gray font-light leading-relaxed" data-id="element-120">
              <p data-id="element-121">
                Bienvenue chez Dispel Your Tattoo, un espace entièrement dédié
                au détatouage, situé au sein du salon Pleine Lune Tattoo à
                Martigny, Suisse.
              </p>
              <p data-id="element-122">
                Mon travail est exclusivement concentré sur l'effacement de
                tatouages, depuis plusieurs années, ce qui me permet de proposer
                une expertise spécialisée et adapté à chaque type de peau.
              </p>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>;
};